import { cn } from '../utils'

export function Switch(props: {
  value: boolean
  onChange: (val: boolean) => void
  className?: string
  disabled?: boolean
}) {
  const { value, className, onChange, disabled } = props

  return (
    <label
      className={cn(
        'w-15 relative inline-block h-8 cursor-pointer',
        disabled && 'pointer-events-none opacity-50',
        className,
      )}
    >
      <input
        type="checkbox"
        className="peer hidden"
        checked={value}
        onChange={() => {
          if (disabled) {
            return
          }
          onChange(!value)
        }}
      />
      <div className="peer-checked:bg-primary h-full w-full rounded-full bg-[#717171] transition-colors duration-300" />
      <div className="absolute -top-[2px] left-0 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md transition-all duration-300 peer-checked:translate-x-[24px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          className={cn('text-[#717171] transition-transform duration-300', value ? 'scale-100' : 'scale-0')}
        >
          <path d="M1 6L5.5 10.5L15 1" stroke="currentColor" strokeWidth={2} />
        </svg>
      </div>
    </label>
  )
}
